<template>
  <UIModal v-model="isOpen" blured close-button @closed="emit('closed')">
    <!-- Header -->
    <template #header>
      <h2 class="halloween-expedition-modal__title">{{ $t('HalloweenExpeditionStartedModalTitle') }}</h2>
    </template>

    <!-- Content -->
    <div class="halloween-expedition-modal__content">
      <div class="halloween-expedition-modal__text">
        <p>
          {{
            $t('HalloweenExpeditionStartedModalText1', {
              location: $t(props.locationName)
            })
          }}
        </p>
      </div>

      <div class="halloween-expedition-modal__pirates-img">
        <img src="/img/halloween/items/three-pirates.png" alt="three-pirates" />
      </div>

      <div class="halloween-expedition-modal__text">
        <p>
          {{ $t('HalloweenExpeditionStartedModalText2') }}
        </p>
      </div>
    </div>

    <!-- Footer -->
    <template #footer>
      <div class="halloween-expedition-modal__footer">
        <HalloweenGenericButton :disabled="isProcessing" @click="handleSubmit">
          {{ $t('HalloweenExpeditionStartedModalButton') }}
        </HalloweenGenericButton>
      </div>
    </template>
  </UIModal>
</template>

<script setup lang="ts">
const props = defineProps<{
  locationName: string;
}>();

const isOpen = defineModel<boolean>({ default: false });
const isProcessing = ref(false);
const halloween = useHalloweenStore();

const emit = defineEmits<{
  (e: 'closed'): void;
  (e: 'submit'): void;
}>();

function handleSubmit() {
  isProcessing.value = true;
  halloween
    .updateUserExpeditions()
    .then(() => {
      emit('submit');
    })
    .finally(() => {
      isOpen.value = false;
      isProcessing.value = false;
    });
}
</script>

<style lang="scss" scoped>
.halloween-expedition-modal {
  &__title {
    font-family: 'PT Serif', serif;
    font-size: 32px;
    font-weight: bold;
    line-height: 30px;
    color: #ffffff;
    text-align: center;
    padding: 0 24px 8px;

    @media (min-width: 640px) {
      padding: 0 48px 8px;
    }
  }

  &__content {
    font-family: 'PT Serif', serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 110%;
    text-align: center;
    color: #dedede;
    padding: 0 24px;

    max-width: 600px;
    margin: 0 auto;

    @media (min-width: 640px) {
      padding: 0 48px;
    }

    @media screen and (max-width: 640px) {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }

  &__text {
    margin-bottom: 20px;
  }

  &__pirates-img {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;

    img {
      max-width: 180px;
      width: 100%;
      height: auto;
      display: block;
    }
  }

  &__footer {
    display: flex;
    justify-content: center;
  }
}
</style>
